import { IFrameNavTab, IRouteConfigMeta } from '@/shared/interfaces/route-config-meta';

type TTranslationContext = {
    $ts: (key: string, values?: Record<string, unknown>) => string;
};

export const getTranslatedText = (
    vm: TTranslationContext,
    fallback: string,
    translationKey?: string,
): string => {
    if (!translationKey) return fallback;

    const translated = vm.$ts(translationKey);
    return typeof translated === 'string' && translated.length ? translated : fallback;
};

export const getRouteMetaTitle = (
    vm: TTranslationContext,
    route?: { meta?: unknown } | null,
): string => {
    const meta = route?.meta as IRouteConfigMeta | undefined;
    const fallback = meta?.dynamicTitle ? meta.dynamicTitle() : meta?.title ?? '';
    return getTranslatedText(vm, fallback, meta?.titleKey);
};

export const getIFrameNavTabLabel = (
    vm: TTranslationContext,
    tab: Pick<IFrameNavTab, 'label' | 'labelKey'>,
): string => getTranslatedText(vm, tab.label, tab.labelKey);
